import { ref, onMounted, onUnmounted } from 'vue'
import { getKeyboardOverlap } from '@/utils/viewport.js'

/**
 * 监听键盘弹出/收起（iOS 走 visualViewport，Android 靠 window resize 兜底），
 * 返回被键盘遮挡的高度、当前可视视口高度，并在每次变化时回调，供调用方重新滚动到底部。
 */
export function useKeyboardOffset(onChange) {
  const keyboardOffset = ref(0)
  const viewportHeight = ref(window.innerHeight)
  let lastOverlap

  const update = () => {
    const vv = window.visualViewport
    viewportHeight.value = vv ? vv.height : window.innerHeight

    // iOS WKWebView 在 fixed 定位的输入框获得焦点时会把整个 layout viewport 上推以让它可见
    // （表现为 visualViewport.offsetTop 非 0）。容器高度已经用 viewportHeight 收缩到键盘之上，
    // 不需要这层原生滚动——纠正回去，否则页头/消息区会被一起推出可视区（真机复现）。
    if (vv && vv.offsetTop) {
      window.scrollTo(0, 0)
    }

    const overlap = getKeyboardOverlap(window.innerHeight, vv)
    if (overlap === lastOverlap) return
    lastOverlap = overlap
    keyboardOffset.value = overlap
    onChange?.(overlap)
  }

  onMounted(() => {
    window.visualViewport?.addEventListener('resize', update)
    window.visualViewport?.addEventListener('scroll', update)
    window.addEventListener('resize', update)
  })

  onUnmounted(() => {
    window.visualViewport?.removeEventListener('resize', update)
    window.visualViewport?.removeEventListener('scroll', update)
    window.removeEventListener('resize', update)
  })

  return { keyboardOffset, viewportHeight }
}
